import { store } from '@/app/app-store';
import {
  AccountModel,
  CompanyModel,
  ActivationOperationModel,
  ApplicationModel,
  AccountProviderModel,
} from '@/app/shared/models';
import { refsService as refs } from '@/app/shared/refs.service';
import { env } from '@/environments';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({ store, name: 'companyModule', namespaced: true, dynamic: true })
export class CompanyModule extends VuexModule {
  public company: CompanyModel = new CompanyModel();
  public account: AccountModel = new AccountModel();
  public activations: ActivationOperationModel[] = [];
  public activationsFiltered: ActivationOperationModel[] = [];
  public applicationPermitted = false;
  public applications: ApplicationModel[] = [];
  public applicationsFiltered: ApplicationModel[] = [];
  public accountProviders: AccountProviderModel[] = [];

  @Mutation
  public SET_COMPANY(company: CompanyModel) {
    this.company = company;
  }
  @Mutation
  public SET_ACCOUNT(account: AccountModel) {
    this.account = account;
  }
  @Mutation
  public SET_APPLICATION_PERMITTED(permitted: boolean) {
    this.applicationPermitted = permitted;
  }
  @Mutation
  public SET_ACTIVATIONS(activations: ActivationOperationModel[]) {
    this.activations = activations;
    this.applications = [];
    this.activationsFiltered = activations;
    this.activations.forEach((activation) => {
      if (
        !this.applications.some((application) => {
          return application.Id == activation.Application.Id;
        })
      ) {
        if (activation.Application.Type == refs.enums.ApplicationType.Web) {
          this.applications.push(activation.Application);
          this.applicationsFiltered.push(activation.Application);
        }
      }
    });
  }
  @Mutation
  public SET_ACTIVATIONS_FILTERED(
    activationsFiltered: ActivationOperationModel[]
  ) {
    this.activationsFiltered = activationsFiltered;
    this.applicationsFiltered = [];
    const owner = refs.modules.user.userInfo.owner;
    const accounts: string[] = [];
    if (!owner) {
      refs.modules.user.profiles.map((profile) => {
        accounts.push(profile.AccountId);
      });
    }
    this.activationsFiltered.forEach((activation) => {
      if (
        !this.applicationsFiltered.some((application) => {
          return application.Id == activation.Application.Id;
        })
      ) {
        if (activation.Application.Type == refs.enums.ApplicationType.Web) {
          if (owner) {
            this.applicationsFiltered.push(activation.Application);
          } else {
            if (accounts.includes(activation.AccountId)) {
              this.applicationsFiltered.push(activation.Application);
            }
          }
        }
      }
    });
  }
  @Mutation
  public SET_PROVIDER(providers: AccountProviderModel[]) {
    this.accountProviders = providers;
  }
  @Action({ commit: 'SET_COMPANY', rawError: true })
  public loadCompanyById(id: string) {
    return refs.services.company.getCompanyById(id);
  }
  @Action({ commit: 'SET_ACCOUNT', rawError: true })
  public loadAccountById(id: string) {
    return refs.services.company.getAccountById(id);
  }

  @Action({ commit: 'SET_ACTIVATIONS', rawError: true })
  public async loadActivationsByAccountId() {
    const activationList: ActivationOperationModel[] = [];
    this.SET_APPLICATION_PERMITTED(false);
    if (refs.modules.user.userInfo.company) {
      const activations = await refs.services.company.getActivationsByCompanyId(
        refs.modules.user.userInfo.company
      );

      activations.map((activation) => {
        if (
          refs.modules.user.userInfo.owner ||
          refs.modules.user.profiles.some(
            (p) => activation.Application.Id == p.ApplicationId
          )
        ) {
          if (activation.Application.Code != env.applicationCode) {
            activationList.push(activation);
          } else {
            this.SET_APPLICATION_PERMITTED(true);
          }
        }
      });
    }

    return activationList;
  }

  @Action({ commit: 'SET_PROVIDER', rawError: true })
  public async getProvidersByAccoundId() {
    if (refs.modules.user.userInfo.company) {
      return await refs.services.company.getProvidersByCompanyId(
        refs.modules.user.userInfo.company
      );
    }
  }
}
